<template>
  <div>
    <v-card>
      <v-card-title>
        <v-icon color="primary"> mdi-bell-outline </v-icon>
        <span class="pl-2">{{ $t('pages.create_notification') }}</span>
        <v-spacer></v-spacer>
        <v-btn depressed color="secondary" @click="$router.go(-1)" class="mx-1">
          {{ $t('pages.back') }}
          <v-icon right dark> mdi-keyboard-return </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          class="multi-col-validation mt-6"
          lazy-validation
        >
          <v-row>
            <v-col md="12" cols="12">
              <v-text-field
                v-model="notification.title"
                :label="$t('table.title')"
                dense
                outlined
                required
                :rules="nameRules"
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12">
              <v-select
                v-model="notification.role_ids"
                dense
                outlined
                multiple
                chips
                :label="$t('table.roles')"
                :items="roles"
                item-text="role"
                item-value="value"
                clearable
                :rules="rolesRules"
              ></v-select>
            </v-col>
            <v-col md="6" cols="12">
              <v-autocomplete
                v-model="notification.user_ids"
                dense
                outlined
                multiple
                chips
                :label="$t('table.users')"
                :items="usersWithSelectAll"
                item-text="name"
                item-value="id"
                clearable
                :loading="status === 'loading-users'"
                @change="handleUserChange"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index >= 0 && index < 3">
                    <span>{{ item.name }}</span>
                  </v-chip>
                  <span v-if="index === 3" class="grey--text text-caption">
                    (+{{ notification.user_ids.length - 3 }} others)
                  </span>
                </template>
                <template v-slot:item="data">
                  <v-list-item
                    v-if="data.item.id === selectAllId"
                    @click.stop="toggleSelectAll"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ isAllSelected ? 'Deselect All' : 'Select All' }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                    v-else
                    v-bind="data.attrs"
                    @click="data.on.click"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ data.item.name }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col md="12" cols="12">
              <v-textarea
                v-model="notification.description"
                :label="$t('table.message')"
                dense
                outlined
                required
                rows="4"
                :rules="messageRules"
              ></v-textarea>
            </v-col>

            <v-col cols="12">
              <v-btn
                color="primary"
                class="me-3 mt-4"
                @click="createNotification"
                :loading="isCreating"
              >
                {{ $t('actions.save') }}
              </v-btn>
              <v-btn color="secondary" outlined class="mt-4" @click="cancel">
                {{ $t('actions.cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      isCreating: false,
      notification: {
        title: '',
        description: '',
        role_ids: [],
        user_ids: [],
      },
      valid: true,
      nameRules: [(v) => !!v || this.$t('messages.is_required')],
      messageRules: [(v) => !!v || this.$t('messages.is_required')],
      rolesRules: [(v) => v.length > 0 || this.$t('messages.is_required')],
      roles: [
        // { role: this.$t('roles.admin'), value: 1 },
        // { role: this.$t('roles.school'), value: 2 },
        { role: this.$t('roles.driver'), value: 3 },
        { role: this.$t('roles.parent'), value: 4 },
        // { role: this.$t('roles.guardian'), value: 5 },
        { role: this.$t('roles.student'), value: 6 },
      ],
      users: [],
      status: '',
      selectAllId: '__select_all__',
    };
  },
  computed: {
    usersWithSelectAll() {
      return [{ id: this.selectAllId, name: 'Select All' }, ...this.users];
    },
    isAllSelected() {
      return (
        this.users.length > 0 &&
        this.notification.user_ids.length === this.users.length
      );
    },
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    cancel() {
      this.$router.go(-1);
    },
    createNotification() {
      if (!this.validate()) return;
      this.isCreating = true;
      const data = { ...this.notification };
      axios
        .post(`/notifications/create`, data)
        .then(() => {
          this.$notify({
            title: 'Success',
            text: 'Notification created!',
            type: 'success',
          });
          this.$router.go(-1);
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Error creating notification',
            type: 'error',
          });
        })
        .then(() => {
          this.isCreating = false;
        });
    },
    getUserList() {
      this.status = 'loading-users';
      const params = { role_ids: this.notification.role_ids };
      axios
        .get(`/users/all-list`, { params })
        .then((response) => {
          this.users = response?.data;
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Error loading users',
            type: 'error',
          });
        })
        .then(() => {
          this.status = '';
        });
    },
    toggleSelectAll() {
      this.notification.user_ids = this.isAllSelected
        ? []
        : this.users.map((user) => user.id);
    },
    handleUserChange(val) {
      this.notification.user_ids = val.filter((id) => id !== this.selectAllId);
    },
  },
  watch: {
    'notification.role_ids': {
      deep: true,
      handler() {
        this.getUserList();
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
